import { render, staticRenderFns } from "./button-with-icon.vue?vue&type=template&id=d224b778"
import script from "./button-with-icon.vue?vue&type=script&lang=js"
export * from "./button-with-icon.vue?vue&type=script&lang=js"
import style0 from "./button-with-icon.vue?vue&type=style&index=0&id=d224b778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports